<template>
    <div class="lms__superadmin_users_profile_edit_learninghistory_events">
        <component-list
            :component-grid="DashboardListLearnerGrid"
            :component-table="DashboardListLearnerTable"
            :component-table-name="'lms-superadmin-users-profile-edit-learning-history-events'"
            :filters-active="true"
            :filter-search-queryable="true"
            :filter-search-placeholder="'Search event name'"
            :filter-select-prefix="''"
            :get-pagination-getter="'getUserHistoryPagination'"
            :get-items-getter="'getUserHistory'"
            :get-items-dispatch="'getUserHistory'"
            :get-items-dispatch-data="{ learnerId: userId, type: 'event' }"
            :item-name="['event', 'events']"
        />
    </div>
</template>

<script>
import ComponentList from '@/components/default/shared/ComponentList'
import DashboardListLearnerTable from '@/components/dashboard/list/learner/DashboardListLearnerTable'
import DashboardListLearnerGrid from '@/components/dashboard/list/learner/DashboardListLearnerGrid'

export default {
  name: 'lms-superadmin-users-profile-edit-learning-history-events',
  components: { ComponentList },
  data () {
    return {
      DashboardListLearnerTable,
      DashboardListLearnerGrid
    }
  },
  computed: {
    userId () {
      return this.$route.params.userId
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/dashboard/list/_dashboardlistcompleteitems.scss";
</style>
